/**
 * The message the Staff tab's "Create recipe" button copies: everything the Claude Agent needs to run
 * the recipe-kitchen skill on this video, ready to paste into a Slack thread. Slack turns a paste this
 * long into a file, which the agent downloads along with the thread.
 */
export interface RecipeRequest {
    videoId: number;
    videoName: string;
    /** Signed link to the published render, for frames; null when one couldn't be produced. */
    renderUrl: string | null;
    /** The video's state: the reference annotation with its scene-design changes. */
    videoState: string;
}

export function buildRecipeRequest({
    videoId,
    videoName,
    renderUrl,
    videoState,
}: RecipeRequest): string {
    const render = renderUrl
        ? `Published render (signed link, valid for 7 days): ${renderUrl}`
        : "Published render: no single render link is available, so I'll attach the MP4.";
    return [
        'Please follow the recipe-kitchen skill in the web repo (.claude/skills/recipe-kitchen) to make a toolbox recipe from this video.',
        '',
        `Video: ${videoName} (id ${videoId})`,
        render,
        '',
        'Video state, copied from the editor (reference annotation with its changes from the scene designs):',
        '',
        videoState,
    ].join('\n');
}
